import React, { useState, useEffect } from "react";
import { PageHeader, Row, Col, Button, Form, Select, Input } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import AdminBreadCrumb from "../../components/layout/AdminBreadCrumb";
import ProgrammeService from "../../api/programme.service";
import memberService from "../../api/member.service";
import { SUCCESS_STATUS } from "../../utility/Constants";
import { STUDENT_WISE_COLLECTION } from "../../utility/URL";
import commonUtility from "../../utility/Utils";

const { Option } = Select;

const StudentWiseCollection = () => {
  const [form] = Form.useForm();
  const [programmeList, setProgrammeList] = useState([]);
  const [memberList, setMemberList] = useState([]);
  const [programmeID, setProgrammeID] = useState(null);
  const [loading, setLoading] = useState(false);
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    setUserInfo(commonUtility.getLoggedInUserInfo());
  }, []);

  useEffect(() => {
    ProgrammeService.programmeList().then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        setProgrammeList(res.data.response_data);
      }
    });
  }, []);

  useEffect(() => {
    setMemberList([]);
    form.setFieldsValue({ member_id: null, enrollment_id: null });

    if (!programmeID) return;

    memberService
      .getActiveMemberByProgrammeId({ formdata: { program_id: programmeID } })
      .then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          setMemberList(res.data.response_data);
        }
      });
  }, [programmeID]);

  const onFinish = (values) => {
    console.log("Submitted Data:", values);  
    if (!userInfo || !userInfo.yearID) {
      console.error("User info is missing or invalid.");
      return;
    }

    const printURL = `${STUDENT_WISE_COLLECTION}/${values.enrollment_id}/${userInfo.yearID}`;
    window.open(printURL, "_blank");
  };

  return (
    <div className="inside-main-content">
      <AdminBreadCrumb />
      <div className="box-style">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Student Wise Collection"
        />
        <div className="form-input-style">
          <Form
            form={form}
            layout="vertical"
            autoComplete="off"
            onFinish={onFinish}
            initialValues={{ enrollment_id: null }} 
          >
            <Row gutter={20}>
              <Col xs={24} xl={6}>
                <Form.Item
                  name="programme_id"
                  label="Programme"
                  rules={[{ required: true, message: "Select Programme" }]}
                >
                  <Select
                    placeholder="Select Programme"
                    onSelect={(value) => {
                      setProgrammeID(value);
                      form.setFieldsValue({ member_id: null, enrollment_id: null }); 
                    }}
                  >
                    {programmeList.map(({ programme_id, programme_name }) => (
                      <Option key={programme_id} value={programme_id}>
                        {programme_name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} xl={6}>
                <Form.Item
                  name="member_id"
                  label="Search (Name | Mobile | Father Name)"
                  rules={[
                    { required: true, message: "Select Member / Student" },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Search to Select"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    onSelect={(value, option) => {
                      form.setFieldsValue({
                        member_id: value,
                        enrollment_id: option.enrollmentid,
                      });
                    }}
                  >
                    {memberList.map(
                      ({
                        member_id,
                        enrollment_id,
                        member_fname,
                        member_lname,
                        primary_mobile,
                        father_name,
                      }) => (
                        <Option
                          key={member_id}
                          value={member_id}
                          enrollmentid={enrollment_id}
                        >
                          {`${member_fname} ${member_lname} | ${primary_mobile} ${
                            father_name || ""
                          }`}
                        </Option>
                      )
                    )}
                  </Select>
                </Form.Item>
              </Col>

            
              <Form.Item name="enrollment_id" hidden>
                <Input type="hidden" />
              </Form.Item>

              <Col xs={24} xl={3}>
                <Form.Item label=" ">
                  <Button
                    htmlType="submit"
                    shape="round"
                    loading={loading}
                    className="custom-button-green"
                  >
                    <PrinterOutlined /> Print
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default StudentWiseCollection;
